import CenterContent from "./CenterContent";
import SpaLevelErrorDisplay from "../lib/common/SpaLevelErrorDisplay";

function SpaError({ error }) {
  return (
    <CenterContent drawerDisabled>
      <SpaLevelErrorDisplay error={error} />
    </CenterContent>
  );
}

export default SpaError;
